import React, { useState } from 'react'
import './profile.scss'
import { useLocation } from "react-router-dom";



const Newsletter = () => {
    const location = useLocation();

    const [orgsSelect, setOrgSelect] = useState(false)
    const newsGroups = location.state.newsgroup
   

   
    const [chosed, setChosed] = useState([])
    function handleOrgChange(e,item) {
        // setOrgSelect((current => !current))
      
        if (e.target.id === item.name) { setOrgSelect(true) }
    }

    let org = [{ 'Name': 'bio 1', },
        { 'Name': 'bio 2', },
        { 'Name': 'bio 3',},
        { 'Name': 'bio 4',  },
        { 'Name': 'bio 5',  },]
    

    function handleCheckbox(e, item) {
     
        if (chosed.includes(item.Name) === true) {
            let newarr = chosed.filter((i) => i !== item.Name)
            setChosed(newarr)
        }
        else {
            let added = [...chosed, item.Name]
           
            setChosed(added)
        }
    }
  
    return (
        <main className='newsletter-container'>

            <p className='profile-title'>Nyhedsbrev</p>
            <p className='profile-text'>Administrér nyhedsbreve</p>

            <section style={{paddingBottom:'50px'} }>
               
                   
                {newsGroups.map((item) => (
                    <div key={item.name} className='orgsContainer' id={item.name} onClick={(e) => handleCheckbox(e,item)}> 
                            <p>{item.Name}</p>
                        <div >

                            {chosed.includes(item.Name) ?
                                 <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect x="0.5" y="0.5" width="19" height="19" rx="2.5" stroke="white" />
                                    <path d="M5 8.75L9.5 13.25L15 6.75" stroke="white" stroke-linecap="round" />
                                </svg>
                             
                                    :
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect x="0.5" y="0.5" width="19" height="19" rx="2.5" stroke="white" />
                                </svg>
                            }
                            </div>
                        </div>
                    )) }
                   
                     
               
              
            </section>
        </main>
    )
}

export default Newsletter